module.exports = __webpack_public_path__ + "img/10-6.de1f0254.jpg";